export const getCondrieuData = () => ({
  name: "Condrieu",
  region: "Rhône",
  country: "France",
  description: "Condrieu est l'appellation phare des vins blancs du Rhône septentrional, produisant des vins blancs aromatiques et complexes exclusivement avec le cépage Viognier.",
  type: "subregion",
  area: "150 ha",
  production: "6,000 hectolitres",
  mapAreas: [
    { region: "Condrieu", x: 54, y: 65, color: "#4B164C", size: 3 }
  ],
  characteristics: {
    climate: "Climat continental avec influence méditerranéenne",
    soil: "Sols de granit, schiste et micaschiste",
    viticulture: "Viticulture en terrasses, vendanges manuelles, rendements très limités"
  },
  wineStyles: {
    white: "Vins blancs aromatiques et complexes, avec des notes d'abricot et de fleurs blanches"
  },
  history: "Condrieu produit des vins depuis l'époque romaine. L'appellation est reconnue depuis 1940. Condrieu est l'une des rares appellations au monde à utiliser exclusivement le cépage Viognier.",
  foodPairing: "Poissons, fruits de mer, volailles, fromages affinés, cuisine gastronomique",
  grapeVarieties: [
    {
      name: "Viognier",
      percentage: "100%",
      description: "Cépage unique de Condrieu, produisant des vins blancs aromatiques et complexes",
      characteristics: "Aromatique, complexe, notes d'abricot, de fleurs blanches et de miel",
      wineStyles: "Sec, moyen-corps, aromatique"
    }
  ]
}); 